import { BannerComponentProps, BannerComponentHandler } from './bannercomponent';
import { BannerCSSStyle } from './bannercss';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentState, UIComponentHandler } from '../../../toolkit/uicomponent';
import * as React from 'react';
import { BannerDto, BannerDtoImpl } from '../../../../core/dto/banner/bannerdto';
import { BaseContext } from '../../../../utils/basecontext';
import { ListViewModel } from '../../../toolkit/horizontallist/listviewmodel';
import { CarouselComponent, CarouselComponentProps, CarouselType } from '../../../toolkit/carousel/carouselcomponent';
import { BannerViewModelImpl } from './bannerviewmodel';
// import { TestSwiper } from 'src/com/sixdee/test/testheader/textswiper/testswiper';

export class BannerViewImpl extends UIComponentViewImpl<UIDataModel>
{
    // private nextArrow: HTMLAnchorElement;
    viewModel: ListViewModel<BannerDto>;
    carouselComponent: CarouselComponent<CarouselComponentProps<BannerDto>, UIComponentState>;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);

        this.onBannerClick = this.onBannerClick.bind(this);
        this.startAutoPlay = this.startAutoPlay.bind(this);
        this.stopAutoPlay = this.stopAutoPlay.bind(this);
        this.viewModel = new BannerViewModelImpl(context, this.onBannerClick, this.stopAutoPlay, 
            this.startAutoPlay);
    }

    bindHandlers()
    {
        
    }

    draw(props: BannerComponentProps, state: UIComponentState, cssStyle: BannerCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
     
        this.viewModel.setListDatas( props.listOfBannerDto);

        return (
            <div style={cssStyle.getCarouselDivCSSStyle()}>
                <CarouselComponent slidePerviewMobile={1} ref={(item: any) =>{this.carouselComponent = item;}} isIndicatorRequired={true} slidePerview={3} id="banner" carouselType={CarouselType.BANNER} listViewModel={this.viewModel} context={this.getUIProps().context}/>
            </div>
        );
    }

    getUIComponentHandler(): BannerComponentHandler
    {
        return super.getUIComponentHandler() as BannerComponentHandler;
    }

    getData(): BannerDto
    {
        let request = new BannerDtoImpl();

        return request;
    }

    startAutoPlay()
    {
        if(this.carouselComponent !== null && this.carouselComponent !== undefined)
        {
            this.carouselComponent.startAutoPlay();
        }
    }

    stopAutoPlay()
    {
        if(this.carouselComponent !== null && this.carouselComponent !== undefined)
        {
            this.carouselComponent.stopAutoPlay();
        }
    }

    onBannerClick(bannerDto: BannerDto)
    {
        (this.getUIComponentHandler() as BannerComponentHandler).onBannerClick(bannerDto);
    }
    // getListOfTones()
    // {  let tone1 = new ToneDtoImpl();
    //     tone1.setId("1");
    //     tone1.setToneName("1234rsva");
    //     tone1.setArtistName("987ytrfgbnmk");
    //     tone1.setImgPath("http://placehold.it/120x120&text=image1");
    //     let tone2 = new ToneDtoImpl();
        
    //     tone2.setId("2");
    //     tone2.setToneName("1234rsva");
    //     tone2.setArtistName("987ytrfgbnmk");
    //     tone2.setImgPath("http://placehold.it/120x120&text=image2");

    //     let tone3 = new ToneDtoImpl();
    //     tone3.setId("3");
    //     tone3.setToneName("1234rsva");
    //     tone3.setArtistName("987ytrfgbnmk");
    //     tone3.setImgPath("http://placehold.it/120x120&text=image3");

    //     let tone4 = new ToneDtoImpl();
    //     tone4.setId("4");
    //     tone4.setToneName("1234rsva");
    //     tone4.setArtistName("987ytrfgbnmk");
    //     tone4.setImgPath("http://placehold.it/120x120&text=image4");

    //     let tone5 = new ToneDtoImpl();
    //     tone5.setId("5");
    //     tone5.setToneName("1234rsva");
    //     tone5.setArtistName("987ytrfgbnmk");
    //     tone5.setImgPath("http://placehold.it/120x120&text=image5");

    //     let tone6 = new ToneDtoImpl();
    //     tone6.setId("6");
    //     tone6.setToneName("1234rsva");
    //     tone6.setArtistName("987ytrfgbnmk");
    //     tone6.setImgPath("http://placehold.it/120x120&text=image6");

    //     let tone7 = new ToneDtoImpl();
    //     tone7.setId("7");
    //     tone7.setToneName("1234rsva");
    //     tone7.setArtistName("987ytrfgbnmk");
    //     tone7.setImgPath("http://placehold.it/120x120&text=image7");

    //     let tone8 = new ToneDtoImpl();
    //     tone8.setId("8");
    //     tone8.setToneName("1234rsva");
    //     tone8.setArtistName("987ytrfgbnmk");
    //     tone8.setImgPath("http://placehold.it/120x120&text=image8");

    //     return [tone1, tone2, tone3, tone4, tone5, tone6, tone7, tone8];
    // }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerview.tsx